module.exports = __webpack_public_path__ + "static/media/S (111).867c8340.jpg";